import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const TermsOfService = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Paper elevation={1} sx={{ p: { xs: 3, md: 5 } }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            Terms of Service
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Last updated: April 2, 2026
          </Typography>

          <Box sx={{ mt: 3, '& h6': { mt: 3, mb: 1, fontWeight: 600 }, '& p': { mb: 2, lineHeight: 1.8 } }}>

            <Typography variant="h6">1. Acceptance of Terms</Typography>
            <Typography>
              By accessing or using JyotishSastra (jyotishsastra.com and the JyotishSastra mobile
              application), you agree to be bound by these Terms of Service. If you do not agree to these
              terms, do not use the Service.
            </Typography>

            <Typography variant="h6">2. Description of Service</Typography>
            <Typography>
              JyotishSastra is a platform connecting users with Vedic astrologers for consultations (voice,
              video, and chat). The Service also provides astrological tools including kundli generation,
              ashtakavarga analysis, divisional charts, kundli matching, daily panchanga, and related
              Vedic astrology calculations.
            </Typography>

            <Typography variant="h6">3. User Accounts</Typography>
            <Typography>
              You must register an account to access consultation features. You are responsible for
              maintaining the confidentiality of your account credentials. You must provide accurate and
              complete information during registration. One person may maintain only one user account.
            </Typography>

            <Typography variant="h6">4. Astrologer Services</Typography>
            <Typography>
              Astrologers on JyotishSastra are independent practitioners, not employees of JyotishSastra.
              Astrological consultations are provided for entertainment, spiritual guidance, and personal
              reflection purposes. JyotishSastra does not guarantee the accuracy of astrological readings
              or predictions. Consultations should not be used as a substitute for professional medical,
              legal, financial, or psychological advice.
            </Typography>

            <Typography variant="h6">5. Payments and Billing</Typography>
            <Typography>
              Consultations are billed on a per-minute basis as displayed before the session begins. Users
              must maintain sufficient wallet balance before initiating a consultation. Wallet top-ups are
              processed through our payment gateway. Refunds are issued automatically for consultations
              lasting less than 30 seconds. For other refund requests, contact our support team.
            </Typography>

            <Typography variant="h6">6. Consultation Conduct</Typography>
            <Typography>
              Users and astrologers must conduct themselves respectfully during consultations. Prohibited
              conduct includes: harassment, abusive language, sharing of illegal content, recording
              consultations without consent, and soliciting services outside the platform.
            </Typography>

            <Typography variant="h6">7. Intellectual Property</Typography>
            <Typography>
              All content, features, and functionality of the Service (including astrological algorithms,
              UI design, and branding) are owned by JyotishSastra. Astrological charts generated for you
              are yours to use personally. You may not reproduce, distribute, or commercially exploit any
              part of the Service without written permission.
            </Typography>

            <Typography variant="h6">8. Limitation of Liability</Typography>
            <Typography>
              JyotishSastra is provided "as is" without warranties of any kind. We are not liable for any
              indirect, incidental, or consequential damages arising from your use of the Service. Our total
              liability is limited to the amount you paid for the Service in the preceding 12 months.
              Astrological content is for guidance purposes only and we make no claims regarding its accuracy.
            </Typography>

            <Typography variant="h6">9. Service Availability</Typography>
            <Typography>
              We strive to maintain continuous service availability but do not guarantee uninterrupted
              access. The Service may be temporarily unavailable due to maintenance, updates, or
              circumstances beyond our control. We will endeavor to provide advance notice of scheduled
              maintenance.
            </Typography>

            <Typography variant="h6">10. Termination</Typography>
            <Typography>
              We reserve the right to suspend or terminate your account for violation of these Terms.
              You may delete your account at any time through your account settings. Upon termination,
              your right to use the Service ceases immediately. Any remaining wallet balance will be
              refunded per our refund policy.
            </Typography>

            <Typography variant="h6">11. Governing Law</Typography>
            <Typography>
              These Terms are governed by the laws of India. Any disputes arising from these Terms shall
              be subject to the exclusive jurisdiction of the courts in Chennai, Tamil Nadu, India.
            </Typography>

            <Typography variant="h6">12. Changes to Terms</Typography>
            <Typography>
              We may update these Terms from time to time. Continued use of the Service after changes
              constitutes acceptance of the new Terms. We will notify registered users of material changes
              via email or in-app notification.
            </Typography>

            <Typography variant="h6">13. Contact Us</Typography>
            <Typography>
              For questions about these Terms of Service, contact us at:
              <br />
              Email: support@jyotishsastra.com
              <br />
              Website: https://jyotishsastra.com
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default TermsOfService;
